import { gql } from "@apollo/client";


export const VALIDATE_EXIST_PACIENTE_BY_DNI = gql`
query validateExistPacienteByDni(
    $idPaciente: Int
    $dni: String!
    $idTipoDocumento: Int!
 ){
    validateExistPacienteByDni(
        input: {
            idPaciente: $idPaciente,
            dni: $dni,
            idTipoDocumento: $idTipoDocumento
        }
    ){
        idPaciente
        idDelegacion
        idDelegacionNavigation{
            descripcion
        }
        mail
        idTipoDocumento
        numeroDocumento
        nombre
        apellido
        fechaNacimiento
        edad
        sexo
        familiar
        familiarTelefono
        vinculo
        informacionAdicional
        fechaAlta
        idUsuario
        fechaEstado
        fechaModificacion
        codSAPPaciente
        edadDesc
        gM
        fechaDesdePaciente
        fechaHastaPaciente
        estadoAPP
        latitud
        longitud
        telefonoUbicacion
        observacionesUbicacion
        sinDoc
        telefonoContacto
    }
}
`;